import jQuery from 'jquery'
window.jQuery = window.$ = jQuery
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import Spinner from 'vue-simple-spinner'
import { makeServer } from "./server"




Vue.config.productionTip = false
Vue.use(VueRouter)

Vue.component('vue-simple-spinner', Spinner)


Vue.use((Vue) => {
  Vue.prototype.$bubble = function $bubble(eventName, ...args) {
    // Emit the event on all parent components
    let component = this;
    do {
      component.$emit(eventName, ...args);
      component = component.$parent;
    } while (component);
  };
});

if (process.env.VUE_APP_MODE) {
  if (process.env.VUE_APP_MODE == 'local') {
    makeServer()
  }
}


import BoosterLanding from './components/BoosterLanding.vue'
import SelfEnrollment from './components/SelfEnrollment.vue'
import EnrollmentResult from './components/EnrollmentResult.vue'

const routes = [
  {path: '/booster/landing/*', component: BoosterLanding},
  {path: '/booster/begin/:pid/:lid', component: BoosterLanding},
  {path: '/booster/decline/:pid/:lid', component: BoosterLanding},
  {path: '/booster/tq/view/:bid/:page/view', component: BoosterLanding},
  {path: '/booster/tq/private/:bid', component: BoosterLanding},
  {path: '/booster/unsubscribe/:pid/:lid', component: BoosterLanding},
  {path: '/booster/unsubscribe-confirm/:pid/:lid', component: BoosterLanding, alias: ['/booster/unsubscribe/:pid/:lid']},
  {path: '/register/:registrationKey', component: SelfEnrollment, props: true },
  {path: '/register-result', name: 'register-result', component: EnrollmentResult, props: true},
  {path: '/test', component: BoosterLanding },
  {path: '*', component: BoosterLanding}
]

const router = new VueRouter({mode: 'history',  routes: routes})

new Vue({
  components: {
    Spinner
  },
  router,
  render: h => h(App)
}).$mount('#app')
